import _ from 'lodash';
import Promise, { OperationalError } from 'bluebird';

function geocode(street, npa, city) {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();

    const address = `${street}, ${npa} ${city}, Switzerland`;

    geocoder.geocode({ address }, (results, status) => {
      if (status !== 'OK' || !results[0]?.geometry?.location) {
        return reject(new OperationalError('Location not found'));
      }

      const { lat, lng } = results[0].geometry.location;
      resolve({ lat: lat(), lng: lng() });
    });
  });
}

const throttledGeocode = _.throttle(geocode, 1000);
export default throttledGeocode;
